export default __webpack_public_path__ + "static/media/070_boost.av1.ea86467f.mp4";